import { Expose, Transform } from "class-transformer";

export class Area {
  @Expose({ name: "지역(SO)" })
  public areaName = "";

  @Expose({ name: "상태(SO)" })
  public state = "";

  @Expose({ name: "주소" })
  public address = "";

  @Expose({ name: "지도이미지" })
  @Transform(({ value }) => {
    if (!Array.isArray(value) || value.length === 0) {
      return "";
    }
    return value[0]?.thumbnails?.full?.url ?? "";
  })
  public image = "";

  @Expose({ name: "세제혜택지역(SO)" })
  @Transform(({ value }) => value === true)
  public taxBenefit = false;

  @Expose({ name: "간이과세자 등록 불가" })
  public isRegDenied = false;
}
